<template>

  <v-col class="px-0">
    <v-row class="mx-0">
        <v-col cols="12" class="py-0 bg-brilliant">
        
          <v-row class="mt-5" v-if="false">

            <v-col cols="11" sm="11" md="10" lg="10" class="mx-auto text-left mb-10">
              <br><br><br>
              <span class="font-main font-large4 pb-1 pt-0 mb-5 pb-5 yellow-pirate">
                * Fonctionnement mathématique
              </span>
            </v-col>
          </v-row>

          <v-row style="" class="">

            <v-col cols="12" sm="12" class="mx-auto px-3 px-md-5 font-oxa text-center blterm">
              <br>
              <h2 class="font-large4 mb-3 yellow-pirate">Simulation</h2>
              <br>
              <br>
              Simulez le Fonctionnement système pirate,<br>
              et suivez l'évolution des différentes valeurs du système.
              <br><br>
              <span class="grey--text">
                Cette simulation reproduit le fonctionnement de la création monétaire au fil du temps,
                <br>et simule des transactions aléatoires entre les comptes.
              </span><br><br>
              <br>
            </v-col>
          </v-row>

          <v-row class="section-divider"></v-row>
          
          <v-row style="" class="black-transparent-up home-section about">
            <v-col cols="12" md="10" class="mx-auto px-3 px-md-5 text-center ">
              <div class="font-large2 yellow-pirate">Une monnaie relative</div>
              <div class="desc">
                <b class="font-">La relativité de la monnaie 
                permet de <u>créer de la monnaie quotidiennement</u>,
                sans provoquer d'inflation. </b>
                <br>
                <div class="text-left pl-5" v-if="showInfo">
                  <br>
                  <hr class="row my-5">
                  <br>
                  Une monnaie relative se mesure de 2 façons différentes, avec 2 unités de mesure différentes.
                  <br>
                  Dans le cas de la Monnaie Pirate on utilise : les <b>ùnités (ù)</b> et les <b>PRT</b>.
                  <br><br>
                  Les <b>ùnités</b> correspondent à la <b>valeur absolue</b> de la monnaie.<br>
                  Les <b>PRT</b> correspondent à la <b>valeur relative</b>.
                  <br><br>
                  Le système créé <b>seulement</b> des ùnités.<br>
                  Mais l'utilisateur ne manipule que des PRT, parce que les prix s'expriment toujours en PRT.
                  <br><br>
                  La valeur du PRT est recalculée tous les jours selon la formule suivante :
                  <br><br>
                  <span class="font-medium bold font-oxa">1 PRT = Masse monétaire (ù) / nombre d'utilisateurs / (365.25 / 12)</span><br><br>
                  <span class="font-medium bold font-oxa">1 PRT = {{  mmTotal.toFixed(4) }} ù / {{ accounts.length }} / (365.25 / 12) = {{ monyConvertValue.toFixed(4) }} ù</span>
                  <br><br>
                  Chaque jour la valeur du PRT augmente un peu.
                  <br>
                  Parce que, chaque jour, le système créé des ùnités supplémentaires pour chaque compte courant,<br>
                  ce qui fait augmenter la masse monétaire totale, et donc le résultat final.
                  <br><br>
                  Ce qui signifie qu'il faut de plus en plus d'ùnités chaque jour pour faire 1 PRT, <br> 
                  faisant progressivement perdre leur valeur aux PRT créés par le passé, et annulant les effets de l'inflation.
                  <br><br> 
                  Il y a bien une inflation en valeur absolue (ù), mais pas en valeur relative.
                  <br>
                  <hr class="row my-5">
                  <br>
                </div>
                Pour mieux comprendre et visualiser cette notion de relativité au fil du temps, jetez un oeil à la simulation...

                <br><br> 
                <v-btn large class="bg-yellow-pirate black--text" @click="showInfo = !showInfo">
                  <template v-if="showInfo">Masquer</template>
                  <template v-if="!showInfo">En savoir plus</template>
                </v-btn>
                  
                  <br>
                  <br>
                  <hr class="row my-5">
                  <br>
                <!-- C'est ce calcul qui rend cette monnaie révolutionaire.<br>
                Pour le comprendre, essayez la simulation ! -->
              </div>
            </v-col>
          </v-row>

          <v-row style="" class="">
            <v-col cols="12" sm="5" md="4" lg="4" 
                   class="mx-auto px-3 px-md-5 text-center blterm">
              Masse monétaire initiale<br>
              <small class="grey--text">Quantité de monnaie créée sur les comptes courants</small><br>
              <span class="font-led blueColor font-large">
                {{  mmTotal.toFixed(4) }} ù = <span class="orangeColor">{{  convertUnityMony(mmTotal).toFixed(4) }} PRT</span>
              </span>
              <br><br>
              Masse monétaire réelle<br>
              <small class="grey--text">Quantité de monnaie en circulation sur les comptes courants</small><br>
              <span class="font-led yellow-pirate font-large">
                {{  getMMUnityReelTotal().toFixed(4) }} ù = {{  convertUnityMony(getMMUnityReelTotal()).toFixed(4) }} PRT
              </span>

            </v-col>


            <v-col cols="12" sm="5" md="4" lg="4" 
                   class="mx-auto px-3 px-md-5 text-center blterm">
              % de dépot VS réel<br>
              <span class="font-led  font-large">
                {{  (getMMDepositReelTotal() * 100 / convertUnityMony(getMMUnityReelTotal())).toFixed(2) }} %
              </span><br><br>
              % de dépot VS initial<br>
              <span class="font-led  font-large">
                {{  (getMMDepositReelTotal() * 100 / convertUnityMony(mmTotal)).toFixed(2) }} %
              </span><br><br>
              taux de croissance des dépôts<br>
              <small class="grey--text">sur les 100 derniers jours</small><br>
              <span class="font-led  font-large">
                {{  (growthRate).toFixed(2) }} %
              </span>

            </v-col>


            <v-col cols="12" sm="5" md="4" lg="4" 
                   class="mx-auto px-3 px-md-5 text-center blterm">
              Masse monétaire déposée<br>
              <small class="grey--text">Quantité de monnaie en circulation sur les comptes de dépôt</small><br>
              <span class="font-led purpleColor font-large">
                {{  getMMDepositReelTotal().toFixed(4) }} PRT
              </span><br><br>
              Masse monétaire réelle totale<br>
              <small class="grey--text">Quantité de monnaie totale en circulation 
                (<span class="yellow-pirate">mmReelle</span> + <span class="purpleColor">mmDepot</span>)</small><br>
              <span class="font-led tealColor font-large">
                {{  (convertUnityMony(getMMUnityReelTotal()) + getMMDepositReelTotal()).toFixed(4) }} PRT
              </span><br>
            </v-col>

            <v-col cols="12" sm="5" md="4" lg="4" 
                   class="d-sm-none mx-auto px-3 px-md-5 text-center blterm">
              Valeur d'un PRT<br>
              <span class="font-led yellow-pirate font-large">
                1 PRT = {{ monyConvertValue.toFixed(4) }} ù
              </span>
            </v-col>
            <v-col cols="12">
              <hr>
            </v-col>

            <v-col cols="12" sm="10" 
                   class="mt-10 mx-auto px-3 px-md-5 text-center blterm">
              History<br>
              <ChartHistory :history="history"/>
            </v-col>

            <v-col cols="12" sm="5" md="4" lg="4" 
                   class="d-none d-sm-block mx-auto px-3 px-md-5 text-center blterm">
              Valeur d'un PRT<br>
              <span class="font-led yellow-pirate font-large">
                1 PRT = {{ monyConvertValue.toFixed(4) }} ù
              </span>
            </v-col>

          </v-row>

          <v-row>

            <v-col cols="3" sm="1" md="1" lg="1" class="px-1 px-md-5 text-center --text blterm" :class="accounts.length > 3 ? 'ml-auto' : 'mx-auto'">
              <v-btn @click="initSystem(nbAccounts)" class="mb-2" color="amber"  title="Initialiser la simulation" fab>
                <v-icon color="black">mdi-auto-fix</v-icon>
              </v-btn>
              <br>
              <template v-if="accounts.length <= 3">Initialiser la simulation</template>
              <template v-if="accounts.length > 3">Réinitialiser</template>
            </v-col>
            <v-col v-if="accounts.length > 3" cols="3" sm="1" md="1" lg="1" class="px-1 px-md-5 text-center blterm">
              <v-btn @click="playDay()" class="mb-2" color="purple" fab title="Simuler une journée">
                <v-icon>mdi-play-pause</v-icon>
              </v-btn>
              <br>J+1
            </v-col>
            <v-col v-if="accounts.length > 3" cols="3" sm="1" md="1" lg="1" class="px-1 px-md-5 text-center blterm mr-auto">
              <v-btn @click="playSimulation(!playingSim)" class="mb-2" color="green"  title="Lancer la simulation" fab>
                <v-icon v-if="playingSim">mdi-pause</v-icon>
                <v-icon v-else>mdi-play</v-icon>
              </v-btn>
              <br>Simuler
            </v-col>
            <!-- <v-col v-if="accounts.length > 3" cols="3" sm="1" md="1" lg="1" class="px-1 px-md-5 text-center blterm">
              <v-btn @click="rebase()" class="mb-2" color="blue"  title="" fab>
                <v-icon color="" >mdi-arrow-down</v-icon>
              </v-btn>
              <br>Rebase
            </v-col> -->
            
          </v-row>

          <v-row>
            <v-col cols="12" md="6" class="px-1 px-md-5 text-center blterm mx-auto">
              <v-slider v-model="intervalSim" :min="0" :max="intervalSimMax" step="100" color="yellow"/>
              <small>accélérer / ralentir la simulation</small><br><br>
              <b>J+{{ dayCount }}</b><br><br>
            </v-col>
          </v-row>

          <v-row class="d-none d-md-flex- mb-10">
            <v-col cols="12" md="11" class="d-flex mx-auto">
              <template v-for="(transaction, t) in accountDemoTransactions">
                <div :key="t" class="coin mx-2">
                  
                    <div class="bg-pirate-logo"></div>
                    <div class="content font-oxa text-center">
                      <!-- <v-img src="../../assets/img/monnaie_pirate_logo.png" width="100%" style="position: absoulte; margin:4px 5px 4px 4px;"/> -->

                      {{ (transaction.amountUnity / transaction.monyConvertValue).toFixed(0) }} PRT =
                      <br>
                      {{ transaction.amountUnity.toFixed(4) }} ù
                      <hr>
                      J+{{ accountDemo.walletMain.transactions.length - ((accountDemoTransactions.length > 6 ? 6 : accountDemoTransactions.length)-t) }}
                    </div>

                    <div class="font-oxa text-center">
                      <template v-for="n in parseInt(transaction.amountUnity * 1000)">
                        <span class="d-inline-flex" :key="'tutut'+n">.</span>
                      </template>
                    </div>
                </div>


              </template>
            </v-col>
          </v-row>

          <v-row v-if="showCharts">
            <v-col cols="12" sm="10" md="11" lg="11" class="mx-auto">
              <v-row>
                <v-col cols="12" sm="6" md="6" 
                      class="px-2 text-left mb-3">

                  <WalletSim :account="accounts[0]" :monyConvertValue="monyConvertValue" :startTransaction="startTransaction"/>
                  
                </v-col>
                <v-col cols="12" sm="6" md="6" 
                      class="px-2 text-left mb-3">

                  <WalletSim :account="accounts[1]" :monyConvertValue="monyConvertValue" :startTransaction="startTransaction"/>
                  
                </v-col>
              </v-row>
              <v-row>
                <template v-for="account in accounts.slice(2)">
                  <v-col cols="12" sm="6" md="4" lg="4" 
                        class="px-2 text-left mb-3"
                        :key="account.name">

                    <WalletSim :account="account" :monyConvertValue="monyConvertValue" :startTransaction="startTransaction"/>
                    
                  </v-col>
                </template>
              </v-row>

            </v-col>
          </v-row>

          <v-row style="" class="black-transparent-up home-section d-none d-md-flex">

              <v-col cols="12" sm="10" md="11" lg="12" class="mx-auto ">
                  
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Nom
                          </th>
                          <th class="text-left ">
                            Compte Courant UID
                          </th>
                          <th class="text-left blue--text">
                            ù
                          </th>
                          <th class="blue--text">
                            Graph ù
                          </th>
                          <th class="text-left yellow-pirate">
                            PRT
                          </th>
                          <th class=" yellow-pirate">
                            Graph PRT
                          </th>
                          <th class="text-left">
                            Compte de dépôt UID
                          </th>
                          <th class="text-left yellow-pirate">
                            PRT
                          </th>
                          <th class=" yellow-pirate">
                            Graph PRT
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="account in accounts"
                          :key="account.name"
                        >
                          <td>
                            {{ account.name }}
                          </td>
                          <td>
                            <v-btn v-if="!account.stateAccount" x-small fab class="mr-2" @click="startTransaction(account.walletMain)">
                              <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                            {{ account.walletMain.uid }}
                          </td>
                          <td class="blue--text">
                            {{ account.walletMain.amountUnity.toFixed(4) }} ù
                            <!-- {{ account.walletMain.transactions }} -->
                          </td>
                          <td class="py-3" style="width:200px;">
                            <ChartSparkline :walletMain="account.walletMain" 
                                            :monyConvertValue="monyConvertValue"
                                            :inPRT="false">
                            </ChartSparkline>
                            <!-- {{ account.walletMain.transactions }} -->
                          </td>
                          <td class="yellow-pirate">
                            {{ convertUnityMony(account.walletMain.amountUnity).toFixed(4) }} PRT
                          </td>
                          <td class="py-3" style="width:200px;">
                            <ChartSparkline :walletMain="account.walletMain" 
                                            :monyConvertValue="monyConvertValue"
                                            :inPRT="true">
                            </ChartSparkline>
                            <!-- {{ account.walletMain.transactions }} -->
                          </td>
                          <td>
                            <v-btn v-if="!account.stateAccount" x-small fab class="mr-2" @click="startTransaction(account.walletDeposit)">
                              <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                            {{ account.walletDeposit.uid }}
                          </td>
                          <td class="yellow-pirate">
                            {{ account.walletDeposit.amountMony.toFixed(4) }} PRT
                          </td>
                          <td class="py-3" style="width:200px;">
                            <ChartSparkline :walletDeposit="account.walletDeposit" 
                                            :monyConvertValue="monyConvertValue"
                                            :inPRT="true">
                            </ChartSparkline>
                            <!-- {{ account.walletMain.transactions }} -->
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                
              </v-col>

          </v-row>
            
    
          <v-row>
            <v-col class="pa-0">
              <Footer/>
            </v-col>
          </v-row>
    
        </v-col>
    </v-row>

    
    <v-dialog v-model="showDialogTransfert" width="500">
      
      <v-card>
        <v-card-title class="">
          Transférer des PRT vers un autre compte
        </v-card-title>

        <v-card-text>
          <v-select v-model="selectedWalletTo" 
                    :items="accountsWallets" 
                    item-text="name"
                    item-value="uid"
                    label="Sélectionnez le compte à créditer :" 
                    dense>
          </v-select>

          <h2 class="font-oxa">{{ amountToSend }} PRT</h2>
          <v-slider v-model="amountToSend"
                          :min="0" :max="maxAmount" :step="0.01">
          </v-slider>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showDialogTransfert = false"
          >
            Annuler
          </v-btn>
          <v-btn
            color="green"
            @click="endTransaction()"
          >
            Envoyer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogDemoTransfert></DialogDemoTransfert>
  </v-col>


</template>
  
<style>



.about .desc{
  font-size:18px;
}

@media (max-width: 600px) {
  .about .desc{
    font-size:16px;
  }
  
}
</style>

<script>

import '@/assets/css/home.css';
import '@/assets/css/mainmap.css';
import '@/assets/css/typing-txt.css';

import Footer from '@/components/main-layout/Footer.vue'
import core from '../../plugins/core';
import ChartSparkline from '../../components/home/ChartSparkline.vue';
import DialogDemoTransfert from '../../components/home/DialogDemoTransfert.vue';
//import ChartWalletTuto from '../../components/charts/ChartWalletTuto.vue';
import ChartHistory from '../../components/charts/ChartHistory.vue';
import WalletSim from '../../components/wallet/WalletSim.vue';

// import TypingTxt from '@/components/home/TypingTxt.vue';
// import TypingSection from '@/components/home/TypingSection.vue';


export default {
  name: 'home',
  components: {
    Footer, ChartSparkline, DialogDemoTransfert, ChartHistory, WalletSim //TypingSection, TypingTxt
  },
  data: () => ({
    nbAccountsInit: 1,
    nbAccounts: 6,
    mmTotal : 0, //en ù
    monyConvertValue: 0,
    dayCount: 0,
    accountDemo: null,
    accounts: [],
    accoutsPublic: [
      {
        name: "Trésor public",
        walletMain: {
          uid: "TRESOR",
          amountUnity: 0,
          transactions: []
        }
      },
      {
        name: "CCI",
        walletMain: {
          uid: "CAISSE",
          amountUnity: 0,
          transactions: []
        }
      },
    ],
    chartValues: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
    showDialogTransfert : false,
    selectedWalletFrom: "",
    selectedWalletTo: "",
    amountToSend: 1,
    timerSim: null,
    intervalSim: 1000,
    intervalSimMax: 3000,
    playingSim: false,
    history: [],
    showCharts: false,
    showInfo: false
  }),
  mounted: async function(){
    //this.createAccounts(this.nbAccountsInit)
    this.initSystem(this.nbAccountsInit)
  },
  methods: {
    startTest(){
      //this.minSubArrayLen(7, [2,3,1,2,4,3])
      this.minSubArrayLen(4, [1,4,4])
    },
    initSystem(nAccounts){
      this.dayCount = 0
      this.mmTotal = 0
      this.monyConvertValue = 1 / (365.25 / 12)
      this.createAccounts(nAccounts)
      this.accountDemo = this.accounts[0]
      this.history = []

      let next = this.monyConvertValue
      
      let tresorPublic = this.accounts[0]
      let cci = this.accounts[1]
      this.accounts.filter(a => !a.stateAccount).forEach((account) => {
        let amountU = 1 / 3
        this.saveMonyCreation(account.walletMain,       amountU, next)
        this.saveMonyCreation(tresorPublic.walletMain,  amountU, next)
        this.saveMonyCreation(cci.walletMain,           amountU, next)
      })
      this.showCharts = false
      setTimeout(() => {
        this.calcConvertValue()
        this.showCharts = true
      }, 1000) 
    },
    createAccounts(nAccounts){
      nAccounts = nAccounts != null ? nAccounts : this.nbAccounts
      this.accounts = []
      this.createAccount({ name: "Trésor Public", stateAccount: true })
      this.createAccount({ name: "CCI",           stateAccount: true })
      for(let i = 0; i < nAccounts; i++){
        this.createAccount({ name: "Pirate " + (i+1), stateAccount: false })
      }
    },
    createAccount(info){
      let account = {}
        account.name = info.name // "Pirate " + (i+1)
        account.stateAccount = info.stateAccount
        account.walletMain = {
          uid: this.randUid(),
          amountUnity: 0,
          stateAccount: info.stateAccount,
          transactions: [],
          type: 'MAIN'
        },
        account.walletDeposit = {
          uid: this.randUid(),
          amountMony: 0,
          stateAccount: info.stateAccount,
          transactions: [{
            amountUnity: 0,
            amountMony: 0,
            monyConvertValue : 0,
            nextConvertValue : 0
          },
          {
            amountUnity: 0,
            amountMony: 0,
            monyConvertValue : 0,
            nextConvertValue : 0
          }],
          type: 'DEPOSIT'
        },
        this.accounts.push(account)
    },
    randUid(){
      let uid = ""
      //4 lettres
      for(let i = 0; i < 4; i++){
        let rand = parseInt(Math.random()*26)
        rand = String.fromCharCode(rand + 65)
        uid += rand
      }
      //2 chiffres
      for(let i = 0; i < 2; i++){
        let rand = parseInt(Math.random()*10)
        uid += rand
      }
      return uid
    },
    getMMTotal(){
      return this.mmTotal
      // let mm = 0
      // this.accounts.forEach((account) => {
      //   mm += account.walletMain.amountUnity
      // })
      // return mm
    },
    getMMUnityReelTotal(){
      let mm = 0
      this.accounts.forEach((account) => {
        mm += account.walletMain.amountUnity
      })
      return mm
    },
    getMMDepositReelTotal(){
      let mm = 0
      this.accounts.forEach((account) => {
        mm += account.walletDeposit.amountMony
      })
      return mm
    },
    convertUnityMony(amount){
      return core.convertUnityMony(amount, this.monyConvertValue)
    },
    convertMonyUnity(amountPRT){
      return core.convertMonyUnity(amountPRT, this.monyConvertValue)
    },
    calcConvertValue(){
      //console.log("this.monyConvertValue", this.monyConvertValue)
      if(this.monyConvertValue > 1) this.rebase()
      this.monyConvertValue = this.mmTotal / this.accounts.filter(a => !a.stateAccount).length / (365.25 / 12)
      this.$root.$emit('updateChartTuto')
      this.saveHistory()
    },
    saveHistory(){
      //console.log("saveHistory", this.history.length)
      let today = {
        mmInitialeUnity: this.mmTotal,
        mmInitialePRT: this.convertUnityMony(this.mmTotal),
        mmReelle: this.convertUnityMony(this.getMMUnityReelTotal()),
        mmDepot: this.getMMDepositReelTotal(),
        mmTotalReel: (this.convertUnityMony(this.getMMUnityReelTotal()) + this.getMMDepositReelTotal()),
        percentDepotVSReel: (this.getMMDepositReelTotal() * 100 / this.convertUnityMony(this.getMMUnityReelTotal())),
        percentDepotVSInitial: (this.getMMDepositReelTotal() * 100 / this.convertUnityMony(this.mmTotal)),
        monyConvertValue: this.monyConvertValue
      }
      this.history.push(today)
      if(this.history.length > 100) this.history.shift()
      this.$root.$emit('updateChartTutoHistory')
      //console.log("history", this.history.length, JSON.stringify(today))
    },
    getNextConvertValue(){
      let nbAccounts = this.accounts.filter(a => !a.stateAccount).length
      let mmTotal = this.mmTotal + (this.monyConvertValue * nbAccounts)
      return mmTotal / nbAccounts / (365.25 / 12)
    },
    playDay(){
      let tresorPublic = this.accounts[0]
      let cci = this.accounts[1]
      let next = this.getNextConvertValue()
      this.accounts.filter(a => !a.stateAccount).forEach((account) => {
        let amountU = this.monyConvertValue / 3
        this.saveMonyCreation(account.walletMain,       amountU, next)
        this.saveMonyCreation(tresorPublic.walletMain,  amountU, next)
        this.saveMonyCreation(cci.walletMain,           amountU, next)

        if(account.walletMain.transactions.length > 100) account.walletMain.transactions.shift()
        if(account.walletDeposit.transactions.length > 100) account.walletDeposit.transactions.shift()

      })
      this.calcConvertValue()
      this.dayCount++
    },

    playSimulation(play){
      this.playingSim = play
      if(!this.playingSim) return

      this.playDay()
      for(let i = 0; i < 10; i++){
        this.simulateTransaction()
      }

      this.timerSim = setTimeout(() => {
        this.playSimulation(this.playingSim)
      }, this.intervalSimMax - this.intervalSim)
    },
    simulateTransaction(){ //return
      if(Math.random() > 0.2) return
      let walletFrom = this.getRandWallet()
      //console.log("walletFrom.amountMony", walletFrom, walletFrom.amountMony)
      let walletTo = this.getRandWallet(walletFrom) 
      let amountPRT = Math.random() * ((walletFrom.amountMony != null ? walletFrom.amountMony : this.convertUnityMony(walletFrom.amountUnity))/2)
      let nextConvertValue = this.monyConvertValue
      if(walletTo != null)
      this.saveTransaction(walletFrom, walletTo, amountPRT, nextConvertValue)
    },
    getRandWallet(walletExept){
      let wallet = null
      let n = 0
      while(n < 10 && (wallet == null || wallet.stateAccount == true || (walletExept != null && walletExept.uid == wallet.uid))){
        n++
        let walletType = (Math.random() > 0.5 && walletExept == null) ? "MAIN" : "DEPOSIT"
        let inxWallet = Math.floor(Math.random() * this.accounts.length)
        wallet = walletType == "MAIN" && this.accounts[inxWallet].walletDeposit.amountMony < 100
              ? this.accounts[inxWallet].walletMain
              : this.accounts[inxWallet].walletDeposit
      }
      return wallet
    },
    saveMonyCreation(walletTo, amountUnity, nextConvertValue){
      let transaction = {
        walletFrom: 'NOWHERE',
        walletTo: walletTo.uid,
        amountUnity: amountUnity,
        monyConvertValue : this.monyConvertValue,
        nextConvertValue : nextConvertValue
      }
      //console.log("saveMonyCreation walletTo", walletTo.uid, transaction)
      walletTo.transactions.push(transaction)
      walletTo.amountUnity += amountUnity

      this.mmTotal += amountUnity
    },
    saveTransaction(walletFrom, walletTo, amountPRT, nextConvertValue){
      //console.log("saveTransaction", walletFrom.uid, walletTo.uid, amountPRT, nextConvertValue)
      let amountUnity = this.convertMonyUnity(amountPRT)

      let transaction = {
        walletFrom: walletFrom.uid,
        walletTo: walletTo.uid,
        amountUnity: amountUnity,
        amountMony: amountPRT,
        monyConvertValue : this.monyConvertValue,
        nextConvertValue : (nextConvertValue != null) ? nextConvertValue : this.monyConvertValue
      }

      if(walletFrom != null && walletTo != null){
        if(walletFrom.amountUnity < amountUnity) return 

        let transaction2 = JSON.parse(JSON.stringify(transaction))
        transaction2.amountUnity = amountUnity * (-1)
        transaction2.amountMony = transaction2.amountMony * (-1)

        walletFrom.transactions.push(transaction2)
        if(walletFrom.type == 'MAIN') walletFrom.amountUnity -= amountUnity
        else walletFrom.amountMony -= amountPRT
        
        //console.log("walletTo", walletTo.uid, transaction)
        walletTo.transactions.push(transaction)
        if(walletTo.type == 'MAIN') walletTo.amountUnity += amountUnity
        else walletTo.amountMony += amountPRT

        this.$root.$emit('updateChartTuto')
      }
    },

    startTransaction(accountFrom){
      this.selectedWalletFrom = accountFrom
      this.selectedWalletTo = null
      this.showDialogTransfert = true
    },
    endTransaction(){
      let walletTo = null
      this.accounts.forEach((account) => {
        if(account.walletMain.uid == this.selectedWalletTo) walletTo = account.walletMain
        if(account.walletDeposit.uid == this.selectedWalletTo) walletTo = account.walletDeposit
      })

      //console.log("endTransaction", this.selectedWalletFrom, walletTo, this.amountToSend)
      this.saveTransaction(this.selectedWalletFrom, walletTo, this.amountToSend)
      this.showDialogTransfert = false
    },
    rebase(){
      let rebaseRate = 0.00001
      this.accounts.forEach((account) => {
        account.walletMain.amountUnity = account.walletMain.amountUnity * rebaseRate
        account.walletMain.transactions.forEach((transaction) => {
          transaction.amountUnity = transaction.amountUnity * rebaseRate
          transaction.monyConvertValue = transaction.monyConvertValue * rebaseRate
          transaction.nextConvertValue = transaction.nextConvertValue * rebaseRate
        })
      })
      this.mmTotal = this.mmTotal * rebaseRate
    }
    
  },
    computed: {
      accountsWallets: function(){
            let wallets = []
            this.accounts.filter(a => !a.stateAccount).forEach((account) => {
              wallets.push({
                name : account.name + " - " + account.walletMain.uid + " | courant",
                uid: account.walletMain.uid
              })

              wallets.push({
                name : account.name + " - " + account.walletDeposit.uid + " | dépôt",
                uid: account.walletDeposit.uid
              })
            })
            return wallets
        },
        maxAmount: function(){
          //console.log("this.selectedWalletFrom", this.selectedWalletFrom)
          if(this.selectedWalletFrom.type == "MAIN") return this.convertUnityMony(this.selectedWalletFrom.amountUnity)
          if(this.selectedWalletFrom.type == "DEPOSIT") return this.selectedWalletFrom.amountMony
          return 0
        },
        growthRate: function(){
          if(this.history.length == 0) return 0
          //let total = this.history[this.history.length - 1].mmDepot - this.history[0].mmDepot
          let total = 0
          this.history.forEach((history) => {
            total = history.mmDepot
          })
          let fstValue = this.history[0].mmDepot
          //if(fstValue == 0) fstValue = 1
          if(total == 0) return 0
          let diff =  total - fstValue
          console.log("growthRate", total, fstValue, this.history.length, diff)
          return  (diff / (total) * 100 )
        },
        accountDemoTransactions: function(){
          if(this.accountDemo == null) return []
          return this.accountDemo.walletMain.transactions.filter(trans => trans.walletFrom == "NOWHERE").slice(-6)
        }
    }
}
</script>
